<div class="god-multi-course-select">
  <div class="fields-container">
    <!-- Primera fila: Selector de segmentación -->
    <div class="management-row">
      <enfaf-select-light
        [options]="segmentationTypeOptions"
        [control]="segmentationControl"
        [placeholder]="'Selecciona el tipo de segmentación'"
        [label]="'¿Quién está invitado al evento?'"
      >
      </enfaf-select-light>

      <!-- Segunda columna: Selector de cursos cuando está seleccionado RegisteredStudentsOnly -->
      @if (segmentationControl?.value === EventSegmentationType.RegisteredStudentsOnly) {
        <enfaf-multi-autocomplete-light
          #registeredCoursesAutocomplete
          [label]="'Selecciona los cursos'"
          [placeholder]="'Buscar'"
          [fetchData]="fetchCourses"
        >
        </enfaf-multi-autocomplete-light>
      }
    </div>

    <!-- Lista de cursos seleccionados -->
    @if (segmentationControl?.value === EventSegmentationType.RegisteredStudentsOnly && selectedRegisteredCourses.length > 0) {
      <div class="selected-courses-container">
        <div class="selected-courses-title">Cursos seleccionados:</div>
        <div class="selected-courses-list">
          @for (course of selectedRegisteredCourses; track course) {
            <div class="course-item">
              <span class="course-name">{{ course.title }}</span>
              <app-enfaf-icon
                [svgIconName]="'trash-red'"
                [iconSize]="'16px'"
                [iconStyle]="{ color: '#E03131' }"
                [isButton]="true"
                (onClick)="removeCourse(course)"
                class="remove-icon"
              >
              </app-enfaf-icon>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
